module.exports = __webpack_public_path__ + "media/images/img_Asistente_Documental-981ed1a6.jpg";